/** @jsxImportSource @emotion/react */

import * as BgImageVip from "assets/common/images/member-vip";
import { ListBgType } from "pages/desktop/VipDetails/VipDetailsItem";

import { CurrentLevelStyle } from "./style.index";

type Props = {
  current_level: number;
};

const CurrentLevel = ({ current_level }: Props) => {
  const changeBgVip = () => {
    const listBg: ListBgType = {
      11: BgImageVip.ImageVip1,
      12: BgImageVip.ImageVip2,
      13: BgImageVip.ImageVip3,
      14: BgImageVip.ImageVip4,
      15: BgImageVip.ImageVip5,
      16: BgImageVip.ImageVip6,
      17: BgImageVip.ImageVip7,
      18: BgImageVip.ImageVip8,
      19: BgImageVip.ImageVip9,
    };

    if (current_level >= 0 && current_level < 11) {
      return BgImageVip.ImageVip0;
    }
    if (current_level > 19) {
      return BgImageVip.ImageVip10;
    }

    return listBg?.[current_level];
  };

  const imgBackGroundVip = changeBgVip();
  return (
    <div css={CurrentLevelStyle.wrapper}>
      <img src={imgBackGroundVip} alt="" />
      <div css={CurrentLevelStyle.currentVipTextBox.index}>
        <h4>Cấp độ hiện tại</h4>
        <div css={CurrentLevelStyle.currentVipTextBox.mainLv}>
          VIP{current_level}
        </div>
        <div css={CurrentLevelStyle.currentVipTextBox.subLv}>
          VIP{current_level}
        </div>
      </div>
    </div>
  );
};

export default CurrentLevel;
